import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../common/components/loader/Loader';
import { notify } from '../../../common/utils/notification';
import { useApproveZoomAuth } from '../../../feature/zoom-settings/api/useApproveZoomAuth';

function ZoomCallback() {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const rawState = search.get("state") ?? '';
  const [state, clientRedirectParam] = rawState.split('?clientRedirect=');
  const clientRedirect = clientRedirectParam ?? null;

  const cleanSearch = new URLSearchParams(search);
  cleanSearch.set('state', state);
  const cleanSearchString = decodeURIComponent(`?${cleanSearch.toString()}`);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const { isLoading } = useApproveZoomAuth(`${state}${cleanSearchString}`, {
    enabled: !!state && !!location?.search,
    onSuccess: () => {
      navigate(clientRedirect || '/pages/zoom-settings');
    },
    onError: () => {
      navigate(clientRedirect || '/pages/zoom-settings');
      notify.error(t('zoomNotificationError'));
    }
  });

  if (isLoading) {
    return <Loader />;
  }

  return <></>;
}

export default ZoomCallback